<template>
  <div class="container">
    <div class="top-actions">
      <div class="d-flex gap-2">
        <v-btn 
          icon="mdi-play" 
          class="action-btn" 
          v-if="!started" 
          @click="startWorkshop"
          color="primary"
          variant="text"
        ></v-btn>
        <v-btn
          icon="mdi-stop"
          class="action-btn"
          v-if="started"
          @click="stopWorkshop"
          color="primary"
          variant="text"
        ></v-btn>
        <v-btn 
          class="action-btn qrButton"
          icon="mdi-qrcode"
          v-if="started == true"
          @click="qrdialog = true"
          color="primary"
          variant="text"
        ></v-btn>
        <v-btn
          class="action-btn usersButton"
          icon="mdi-account"
          @click="userDialog=true"
          v-if="started == true"
          color="primary"
          variant="text"
        ></v-btn>
        <v-btn
          class="action-btn filterButton"
          @click="filterDialog=true"
          icon="mdi-filter"
          color="primary"
          variant="text"
        ></v-btn>
        <v-btn
          v-if="started"
          icon="mdi-pencil"
          class="action-btn edit-description-btn"
          @click="projectDescriptionDialog = true"
          color="primary"
          variant="text"
        />
      </div>
    </div>
    <div class="svgContainer" :class="showClass">
      <div class="chart" ref="sunburstChart"></div>
      <!-- Global Risk Score Overlay (sibling, not child) -->
      <div class="global-risk-score-overlay">
        <span class="iso-label">ISO 25010</span>
      </div>
    </div>

    <v-dialog
      transition="dialog-bottom-transition"
      width="95%"
      v-model="detailContentShow"
      :persistent="votingInProgress == true">
      <template v-slot:default>
        <v-card class="detailCard">
          <v-toolbar
              :style="{backgroundColor: selectedSegment.data.color}"
              :title="selectedSegment.data.text[lang].name"
          >
            <v-spacer></v-spacer>
            <v-chip
              v-if="votingInProgress == true && votingEnded == false"
              color="primary"
              variant="elevated"
              class="votes-count-chip"
              size="small"
              style="margin-right: 8px; font-weight: 600; letter-spacing: 0.5px;"
            >
              {{votes.length}} / {{users.length}} Votes
            </v-chip>
          </v-toolbar>
          <div class="detailCardContainer">
            <div v-if="votingEnded == false" class="description-section">
              <div class="font-weight-black mb-2">Description:</div>
              <div class="mb-4">
                <span>{{ llmDescription || selectedSegment.data.text[lang].description }}</span>
              </div>
              <div class="font-weight-black mb-2">Example:</div>
              <div>
                <span>{{ llmExample || selectedSegment.data.text[lang].example }}</span>
              </div>
            </div>
            <div v-if="llmRecommendations.length" class="recommendations-section">
              <div class="font-weight-black mb-2">LLM Recommendations:</div>
              <ul>
                <li v-for="(rec, idx) in llmRecommendations" :key="idx">{{ rec }}</li>
              </ul>
            </div>
            <div class="voting-section">
              <div v-if="votingInProgress == true && votingEnded == false" ref="divider" class="divider-area text-center">
                <span ref="dividerButton" class="divider-button-container">
                  <span class="divider-button">
                    {{ timeString }}
                  </span>
                </span>
              </div>
              <template v-if="votingEnded == true && isGiver">
                <div class="titleCardContainer">Where we want to be</div>
                <div id="cardDataWantToBe" key="cardDataWantToBe" class="cards-row results-grid">
                  <v-card 
                    v-for="(card, index) in cardDataWantToBe" 
                    :key="'cardDataWantToBe'+index" 
                    class="voting-card" 
                    elevation="2" 
                    :class="{'selected-card': selectedVotingValue != undefined && selectedVotingValue.value === card.value}" 
                    @click="selectVotingValue(card)"
                  >
                    <div class="voting-card-headline">{{ card.visualValue }}</div>
                    <div class="voting-card-divider"></div>
                    <div class="voting-card-text">{{ card.text[lang].description }}</div>
                    <div class="voting-card-divider"></div>
                    <div class="voting-card-vote">
                      <div class="number">{{ card.voteCount }} Votes</div>
                      <v-tooltip
                        activator="parent"
                        location="start"
                      >{{ card.voteCount }} team members voted for this option</v-tooltip>
                    </div>
                  </v-card>
                </div>
                <div class="titleCardContainer">Where we are</div>
                <div id="cardDataWhereWeAre" key="cardDataWhereWeAre" class="cards-row results-grid">
                  <v-card 
                    v-for="(card, index) in cardDataWhereWeAre" 
                    :key="'cardDataWhereWeAre'+index" 
                    class="voting-card" 
                    elevation="2" 
                    :class="{'selected-card': selectedVotingItsOnValue != undefined && selectedVotingItsOnValue.value === card.value}" 
                    @click="selectVotingItsOnValue(card)"
                  >
                    <div class="voting-card-headline">{{ card.visualValue }}</div>
                    <div class="voting-card-divider"></div>
                    <div class="voting-card-text">{{ card.text[lang].description }}</div>
                    <div class="voting-card-divider"></div>
                    <div class="voting-card-vote">
                      <div class="number">{{ card.voteCount }} Votes</div>
                      <v-tooltip
                        activator="parent"
                        location="start"
                      >{{ card.voteCount }} team members voted for this option</v-tooltip>
                    </div>
                  </v-card>
                </div>
              </template>
              <template v-else-if="votingEnded == true && !isGiver">
                <div class="votingNotStarted text-center pa-6">
                  Voting not Started
                </div>
              </template>
            </div>
            <div class="detailButtons">
              <v-btn v-if="started == true && votingInProgress == false && selectedSegment.depth > 1 && isGiver" 
                    color="primary" 
                    @click="startSegmentVoting"
                    variant="text">Start Voting</v-btn>
              <v-btn v-if="votingInProgress == true && votingEnded == false && isGiver" 
                    color="primary" 
                    @click="addTime"
                    variant="text">+2:00</v-btn>
              <v-btn v-if="votingInProgress == true && isGiver" 
                    color="error" 
                    @click="cancelVoting"
                    variant="text">Cancel</v-btn>
              <v-btn v-if="votingInProgress == true && votingEnded == false && isGiver" 
                    color="primary" 
                    @click="endVoting"
                    variant="text">End</v-btn>
              <v-btn v-if="votingInProgress == true && votingEnded == true && isGiver" 
                    color="primary" 
                    @click="reVoting"
                    variant="text">Re-Vote</v-btn>
              <v-btn v-if="votingEnded == true" 
                    :disabled="selectedVotingValue == undefined || selectedVotingItsOnValue == undefined"  
                    @click="chooseVoting"
                    color="primary"
                    variant="text">Choose</v-btn>
            </div>
          </div>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
      v-model="userDialog"
      width="500"
      class="app-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          Users
          <v-btn icon="mdi-close" variant="text" @click="userDialog = false" class="close-btn"></v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div v-if="users.length === 0" class="text-center py-4">
            NO USERS IN WORKSHOP
          </div>
          <v-list v-else>
            <v-list-item v-for="user in users" :key="user.id">
              <v-list-item-title>{{ user.name }}</v-list-item-title>
              <template #append>
                <v-btn icon="mdi-delete" variant="text" color="error" @click.stop="deleteUser(user)"></v-btn>
              </template>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="filterDialog"
      width="500"
      class="app-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          Filter
          <v-btn icon="mdi-close" variant="text" @click="filterDialog = false" class="close-btn"></v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-radio-group v-model="showClass">
            <v-radio label="Show All" value="showAll"></v-radio>
            <v-radio label="Where we are" value="showWhereWeAre"></v-radio>
            <v-radio label="Where we want to be" value="showWhereWeWantToBe"></v-radio>
          </v-radio-group>
          <v-switch
            v-model="localRiskAssessmentEnabled"
            label="Enable Risk Assessment"
            class="mt-4"
            @change="onRiskAssessmentToggle"
            color="primary"
          />
          <v-switch
            v-model="localLlmFunctionalityEnabled"
            label="Enable LLM Functionality"
            class="mt-4"
            @change="onLlmFunctionalityToggle"
            color="primary"
          />
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="qrdialog"
      width="400"
      class="app-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          Join Workshop
          <v-btn icon="mdi-close" variant="text" @click="qrdialog = false" class="close-btn"></v-btn>
        </v-card-title>
        <v-card-text class="qr-content">
          <div class="qr-container">
            <qrcode-vue :value="getJoinUrl()" :size="280" level="H" />
          </div>
          <v-btn
            class="mt-6"
            color="primary"
            :href="getLinkUrl()"
            target="_blank"
            block
          >
            OPEN IN BROWSER
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="taskDialogShow"
      width="500"
      class="app-dialog"
    >
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          Tasks
          <v-btn icon="mdi-close" variant="text" @click="taskDialogShow = false" class="close-btn"></v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <div class="d-flex justify-space-between align-center mb-4">
            <h3>Current Tasks</h3>
            <v-btn color="primary" @click="addTask">ADD NEW TASK</v-btn>
          </div>
          <div v-if="tasks.length === 0" class="text-center py-4">
            <div class="text-body-1 text-grey mb-4">No tasks yet</div>
            <v-btn color="primary" @click="addTask">ADD YOUR FIRST TASK</v-btn>
          </div>
          <v-list v-else>
            <v-list-item v-for="task in tasks" :key="task.id">
              {{ task.summary }}
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="projectDescriptionDialog" width="500" class="app-dialog">
      <v-card class="dialog-card">
        <v-card-title class="dialog-header">
          Project Description
          <v-btn icon="mdi-close" variant="text" @click="projectDescriptionDialog = false" class="close-btn"></v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-textarea
            v-model="projectDescription"
            label="Enter a short description of your project"
            auto-grow
            rows="2"
            outlined
            required
          />
          <v-btn color="primary" class="mt-4" @click="saveProjectDescription">Save</v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>

</template>

<script>
import segmentData from '../data/segment.json'
import * as d3 from 'd3';
import QrcodeVue from "qrcode.vue";
import {
  deleteUser as deleteWorkshopUser, deleteVoting, endVoting,
  onActiveVotingVotesChange,
  onUsersChange, saveVoting, setNewVotingEndTime,
  startVoting,
  startWorkshop,
  loadWorkshop
} from "@/workshop/workshopFunctions";
import segmentCardData from "@/data/segmentVoting.json";
import { processAllVotedAspects } from '../utils/riskScore';
import segmentRiskData from '@/data/segmentRisk.json';
import { getAuth } from 'firebase/auth';
import { rtdb } from '@/firebase';
import { ref, get, set } from 'firebase/database';

export default {
  name: "workshopChart",
  components: {QrcodeVue},
  data() {
    return {
      showClass: 'showWhereWeWantToBe',
      started: false,
      userCount: 0,
      users: [],
      votes: [],
      selectedSegment: null,
      userDialog: false,
      filterDialog: false,
      detailContentShow: false,
      qrdialog: false,
      taskDialogShow: false,
      lang: 'en',
      votingInProgress:false,
      activeVoringStart:undefined,
      activeVoringEnd:undefined,
      selectedVotingValue:undefined,
      selectedVotingItsOnValue:undefined,
      votingEnded: false,
      percentTimeLeft: 100,
      timerInterval: null,
      timeString: "",
      cardDataWantToBe: JSON.parse(JSON.stringify(segmentCardData)),
      cardDataWhereWeAre: JSON.parse(JSON.stringify(segmentCardData)),
      chartdata:
          {
            name: 'root',
            children: JSON.parse(JSON.stringify(segmentData))
          },
      taskFormValid: false,
      tasks: [],
      newTask: {
        title: '',
        description: ''
      },
      allVotedAspects: [],
      isGiver: false,
      // LLM integration state
      llmDescription: '',
      llmExample: '',
      llmRecommendations: [],
      llmLoading: false,
      llmError: '',
      // simple caches to avoid repeated LLM latency
      llmContentCache: {},
      llmRecsCache: {},
      llmInFlight: {},
      localRiskAssessmentEnabled: this.riskAssessmentEnabled,
      localLlmFunctionalityEnabled: this.llmFunctionalityEnabled,
      projectDescription: '',
      projectDescriptionDialog: false,
      projectDescriptionDialogShown: false,
    }
  },
  computed: {
    cardsWantToBe() {
      return this.cardDataWantToBe;
    },
    cardsWantToGo() {
      return this.cardDataWhereWeAre;
    },
    customerId() {
      return this.$route.params.customerId;
    },
    workshopId() {
      return this.$route.params.id;
    },
    departmentId() {
      return this.$route.params.departmentId || null;
    },
    projectId() {
      return this.$route.params.projectId || null;
    },
    // The globalRiskScore below matches the 'Overall Risk Score' in the Risk Assessment tab and is always the average of all voted aspects (all results), not just selected topics.
    globalRiskScore() {
      if (!this.allVotedAspects.length) return '0.00';
      const avg = this.allVotedAspects.reduce((sum, a) => sum + Number(a.compositeScore), 0) / this.allVotedAspects.length;
      return avg.toFixed(2);
    }
  },
  async mounted() {
    try {
      await loadWorkshop(this.customerId, this.workshopId, this.departmentId, this.projectId).then(res => {
        console.log('DEBUG: loaded workshop data:', res);
        if(res == null || res == undefined){
          this.assignProportionalValues(this.chartdata, []);
          this.allVotedAspects = [];
          this.started = false;
        } else {
          this.assignProportionalValues(this.chartdata, res.results);
          this.allVotedAspects = processAllVotedAspects(res.results, segmentRiskData);
          // Started derives from startDate timestamp presence (numeric ms)
          this.started = !!res.startDate;
        }
        console.log('DEBUG: started =', this.started);
        this.drawSunburst();
        // If a workshop is already started when opening the page, subscribe to users immediately
        if (this.started) {
          onUsersChange(this.workshopId, this.userChanged, this.departmentId, this.projectId);
        }
      });
      this.loadTasks();
      // After loading workshop data, set isGiver
      const auth = getAuth();
      const uid = auth.currentUser ? auth.currentUser.uid : null;
      const res = await loadWorkshop(this.customerId, this.workshopId, this.departmentId, this.projectId);
      if (res && res.giver && uid) {
        this.isGiver = (res.giver === uid);
      }
    } catch (error) {
      console.error('Error in mounted hook:', error);
    }
  },
  methods: {
    deleteUser(user){
     deleteWorkshopUser(this.workshopId, user.id, this.departmentId, this.projectId);
    },
    getJoinUrl(){
      const customerId = this.$store.getters.getCustomerId;
      const base = window.location.origin;
      return `${base}/customer/${customerId}/workshop/join/${this.workshopId}/${this.lang}`;
    },
    getLinkUrl(){
      const customerId = this.$store.getters.getCustomerId;
      return `/customer/${customerId}/workshop/join/${this.workshopId}/${this.lang}`;
    },
    async startWorkshop(){
      await startWorkshop(this.workshopId, this.departmentId, this.projectId);
      this.started = true;
      this.qrdialog = true;
      await this.loadProjectDescription();
      if (!this.projectDescription && !this.projectDescriptionDialogShown) {
        this.projectDescriptionDialog = true;
        this.projectDescriptionDialogShown = true;
      }
      await onUsersChange(this.workshopId, this.userChanged, this.departmentId, this.projectId);
    },
    async stopWorkshop(){
      this.started = false;
      this.$emit('stopVote');
    },
    userChanged(users){
      this.users = users || [];
      if (this.votingInProgress) {
        this.endVotingIfAllUsersVoted();
      }
    },
    lightenDarkenColor(col, amt) {
      var num = parseInt(col.substr(1), 16);
      var r = (num >> 16) + amt;
      var b = ((num >> 8) & 0x00FF) + amt;
      var g = (num & 0x0000FF) + amt;
      var newColor = g | (b << 8) | (r << 16);
      return "#"+newColor.toString(16);
    },
    async handleSegmentClick(d) {
      this.selectedSegment = d;
      if (!this.localLlmFunctionalityEnabled) {
        this.llmDescription = '';
        this.llmExample = '';
        this.llmRecommendations = [];
        this.llmError = 'LLM functionality is disabled.';
        this.detailContentShow = true;
        this.updateSegmentStyles(`segment-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`);
        return;
      }
      const segmentId = `segment-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`;
      if (this.selectedSegment === d) {
        // Wenn das Segment bereits selektiert ist, deselektieren
        this.selectedSegment = null;
      } else {
        // Segment selektieren
        this.selectedSegment = d;
        this.detailContentShow = true;
        // LLM integration: fetch description, example, and recommendations (non-blocking with cache)
        this.llmLoading = true;
        this.llmError = '';
        this.llmDescription = '';
        this.llmExample = '';
        this.llmRecommendations = [];
        const segmentName = d.data.text[this.lang].name;
        const aspectId = String(d.data.id || '').replace(/\./g, '_');

        // 1) Try RTDB cache first, then local cache
        try {
          const snap = await get(ref(rtdb, `customers/${this.customerId}/workshop/${this.workshopId}/llm/content/${aspectId}`));
          if (snap.exists()) {
            const c = snap.val();
            this.llmDescription = c?.description || '';
            this.llmExample = c?.example || '';
          } else {
            const cachedContent = this.getCachedContent(segmentName);
            if (cachedContent) {
              this.llmDescription = cachedContent.description || '';
              this.llmExample = cachedContent.example || '';
            }
          }
        } catch (e) { /* ignore */ }
        try {
          const rsnap = await get(ref(rtdb, `customers/${this.customerId}/workshop/${this.workshopId}/llm/recs/${aspectId}`));
          if (rsnap.exists()) {
            const recs = rsnap.val();
            if (Array.isArray(recs)) this.llmRecommendations = recs;
          } else {
            const cachedRecs = this.getCachedRecs(segmentName);
            if (cachedRecs && Array.isArray(cachedRecs)) {
              this.llmRecommendations = cachedRecs;
            }
          }
        } catch (e) { /* ignore */ }

        // 2) Refresh in background (dedup + write-through cache)
        Promise.resolve()
          .then(async () => {
            try {
              const inflightKey = `content:${aspectId}`;
              if (this.llmInFlight[inflightKey]) return this.llmInFlight[inflightKey];
              const p = this.fetchSegmentContentLLM(segmentName).then(async (content) => {
              if (content) {
                this.llmDescription = content.description || this.llmDescription;
                this.llmExample = content.example || this.llmExample;
                this.setCachedContent(segmentName, { description: this.llmDescription, example: this.llmExample });
                  try {
                    await set(ref(rtdb, `customers/${this.customerId}/workshop/${this.workshopId}/llm/content/${aspectId}`), {
                      description: this.llmDescription || '',
                      example: this.llmExample || ''
                    });
                  } catch (e) { /* ignore */ }
              }
              }).finally(() => { delete this.llmInFlight[inflightKey]; });
              this.llmInFlight[inflightKey] = p;
              await p;
            } catch (e) {
              this.llmError = 'LLM description/example unavailable.';
            }
          })
          .then(async () => {
            try {
              const inflightKey = `recs:${aspectId}`;
              if (this.llmInFlight[inflightKey]) return this.llmInFlight[inflightKey];
              const p = this.fetchSegmentRecommendationsLLM(segmentName, this.votes, this.globalRiskScore, {}).then(async (recommendations) => {
                this.llmRecommendations = recommendations.recommendations || [];
                this.setCachedRecs(segmentName, this.llmRecommendations);
                try {
                  await set(ref(rtdb, `customers/${this.customerId}/workshop/${this.workshopId}/llm/recs/${aspectId}`), this.llmRecommendations);
                } catch (e) { /* ignore */ }
              }).finally(() => { delete this.llmInFlight[inflightKey]; });
              this.llmInFlight[inflightKey] = p;
              await p;
            } catch (e) {
              // keep any cached/fallback
            }
          })
          .finally(() => {
            this.llmLoading = false;
          });
      }
      this.updateSegmentStyles(segmentId);
    },
    getCachedContent(key) {
      if (this.llmContentCache[key]) return this.llmContentCache[key];
      try {
        const raw = localStorage.getItem('llmContentCache');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        this.llmContentCache = parsed || {};
        return this.llmContentCache[key] || null;
      } catch { return null; }
    },
    setCachedContent(key, value) {
      this.llmContentCache[key] = value;
      try { localStorage.setItem('llmContentCache', JSON.stringify(this.llmContentCache)); } catch (e) { String(e); }
    },
    getCachedRecs(key) {
      if (this.llmRecsCache[key]) return this.llmRecsCache[key];
      try {
        const raw = localStorage.getItem('llmRecsCache');
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        this.llmRecsCache = parsed || {};
        return this.llmRecsCache[key] || null;
      } catch { return null; }
    },
    setCachedRecs(key, value) {
      this.llmRecsCache[key] = value;
      try { localStorage.setItem('llmRecsCache', JSON.stringify(this.llmRecsCache)); } catch (e) { String(e); }
    },
    updateSegmentStyles(segmentId) {
      // Entfernt vorherige Selektionen
      Array.from(document.getElementsByClassName("selected")).forEach(e => e.classList.remove("selected"))
      d3.selectAll('.selected').classed('selected', false);
      if (this.selectedSegment) {
        const el = document.getElementById(segmentId);
        if (el) {
          el.classList.add("selected");
        }
      }
    },
    isSelected(cat, subcat, value){
      var catdata = this.chartdata.children.filter(c => c.id == cat)[0].children.filter(c => c.id == subcat)[0];
      return catdata.value == value;
    },
    setValue(cat, subcat, value, valueItsOn, delay = 0) {
      console.log("Set Value", cat, subcat, value, valueItsOn);
      var catdata = this.chartdata.children.filter(c => c.id == cat)[0].children.filter(c => c.id == subcat)[0];
      catdata.valueWantsToBe = value;
      catdata.valueWhereWeAre = valueItsOn;
      //this.drawSunburst();

      const width = 600;
      const radius = width / 2;
      const arc = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.02)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWantsToBe || 0) * 10 + 2)
          .outerRadius(d => d.y1 + (d.data.valueWantsToBe || 0) * 10);
      const segment = document.getElementById("segment-"+cat+"-"+subcat);
      const newD = arc(catdata.d);

      const arc2 = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.02)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWhereWeAre || 0) * 10 +2)
          .outerRadius(d => d.y1 + (d.data.valueWhereWeAre || 0) * 10);

      const segmentLine = document.getElementById("segmentLine-"+cat+"-"+subcat);
      const newDLine = arc2(catdata.d);
      const colorSegmentLine = value <= valueItsOn ? 'rgba(0,131,0,0.5)' : 'rgba(173,0,0,0.5)'

      const segmentText = document.getElementById("segmentText-"+cat+"-"+subcat);
      const x = arc.centroid(catdata.d)[0];
      const y = arc.centroid(catdata.d)[1];
      const hypotenuse = Math.sqrt(x * x + y * y);
      const xNorm = x / hypotenuse;
      const yNorm = y / hypotenuse;
      const rotation = Math.atan2(yNorm, xNorm) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
      const additionalRotation = rotation < -90 || rotation > 90 ? -180 : 0;
      const newTranslate = `translate(${arc.centroid(catdata.d)}) rotate(${rotation + additionalRotation})`;

      const segmentTextWantWeAreText = document.getElementById("segmentText2-"+cat+"-"+subcat);
      const xWantWeAreText = arc2.centroid(catdata.d)[0];
      const yWantWeAreText = arc2.centroid(catdata.d)[1];
      const hypotenuseWantWeAreText = Math.sqrt(xWantWeAreText * xWantWeAreText + yWantWeAreText * yWantWeAreText);
      const xNormWantWeAreText = xWantWeAreText / hypotenuseWantWeAreText;
      const yNormWantWeAreText = yWantWeAreText / hypotenuseWantWeAreText;
      const rotationWantWeAreText = Math.atan2(yNormWantWeAreText, xNormWantWeAreText) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
      const additionalRotationWantWeAreText = rotationWantWeAreText < -90 || rotationWantWeAreText > 90 ? -180 : 0;
      const newTranslateWantWeAreText = `translate(${arc2.centroid(catdata.d)}) rotate(${rotationWantWeAreText + additionalRotationWantWeAreText})`;



      d3.select(segment) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(2500) // slow down so movement is clearly visible
          .delay(delay)
          .attr('d', newD);

      d3.select(segmentLine) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(2500) // slow down line
          .delay(delay)
          .attr('d', newDLine)
          .attr('stroke', colorSegmentLine);


      d3.select(segmentText) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(2500)
          .delay(delay)
          .attr('transform', newTranslate);

      d3.select(segmentTextWantWeAreText) // Wählen Sie das entsprechende path-Element
          .transition() // Starten einer Transition
          .duration(2500)
          .delay(delay)
          .attr('transform', newTranslateWantWeAreText);

    },
    assignProportionalValues(node, results) {
      let count = 0;
      const children = node.children || [];
      node.value = 0;
      children.forEach(child => {
        if (child.children != undefined && child.children != []) {
          this.assignProportionalValues(child, results)
        } else if(results != undefined && Object.keys(results).includes(child.id)) {
          child.valueWantsToBe = results[child.id].voteWhereWantToBe;
          child.valueWhereWeAre = results[child.id].voteWhereWeAre;
          child.sizeValue = 1 / children.length;
          count = count + 1;
          setTimeout((valueWantsToBe, valueWhereWeAre)=> {
            this.setValue(node.id, child.id, valueWantsToBe, valueWhereWeAre, count*600);
          }, 0, results[child.id].voteWhereWantToBe, results[child.id].voteWhereWeAre);
        } else {
          child.valueWantsToBe = 0;
          child.valueWhereWeAre = undefined;
          child.sizeValue = 1 / children.length;
        }
      });
    },
    getParentSegmentOfActive(){
      for (const cat of segmentData) {
        for(const subcat of cat.children){
          if(subcat.id == this.selectedSegment.data.id){
            return cat;
          }
        }
      }
      return null; // Wenn die ID nicht gefunden wurde
    },
    startSegmentVoting(){
      const durationInMin = 2;
      startVoting(this.workshopId, this.selectedSegment.data.id, durationInMin, this.departmentId, this.projectId);
      this.activeVoringStart = Date.now();
      this.activeVoringEnd = Date.now()+(durationInMin*60*1000);
      onActiveVotingVotesChange(this.workshopId, this.voteChange, this.departmentId, this.projectId);
      this.votingEnded = false;
      this.votingInProgress = true;
      this.updatePercentTimeLeft();
      this.timerInterval = setInterval(this.updatePercentTimeLeft, 100);
    },
    voteChange(newState){
      this.votes = newState || [];
      this.endVotingIfAllUsersVoted();
    },
    selectVotingValue(card){
      this.selectedVotingValue = card;
    },
    selectVotingItsOnValue(card){
      this.selectedVotingItsOnValue = card;
    },
    endVotingIfAllUsersVoted(){
      if (!this.users || !this.votes) return;
      if (this.votes.length === this.users.length) {
        this.stopVoting();
      }
    },
    stopVoting(){
      if(this.$refs.timer != undefined) {
        this.$refs.timer.clear();
      }
      this.votingEnded = true;
      clearInterval(this.timerInterval);
      this.sortCardsOnVotings();
      endVoting(this.workshopId, this.departmentId, this.projectId);
    },
    sortCardsOnVotings(){
      this.cardDataWantToBe = [...this.cardDataWantToBe.map(c => {
        c.voteCount = this.votes.filter(v => v['voteWhereWantToBe'] == c.value).length;
        return c;
      })];
      this.cardDataWantToBe.sort((x, y) => {
        // Zuerst nach 'a' absteigend sortieren
        if (x.voteCount !== y.voteCount) {
          return y.voteCount - x.voteCount;
        }
        // Wenn 'a' gleich ist, dann nach 'b' absteigend sortieren
        return x.value - y.value;
      });

      this.cardDataWhereWeAre = [...this.cardDataWhereWeAre.map(c => {
        c.voteCount = this.votes.filter(v => v['voteWhereWeAre'] == c.value).length;
        return c;
      })];
      this.cardDataWhereWeAre.sort((x, y) => {
        // Zuerst nach 'a' absteigend sortieren
        if (x.voteCount !== y.voteCount) {
          return y.voteCount - x.voteCount;
        }
        // Wenn 'a' gleich ist, dann nach 'b' absteigend sortieren
        return x.value - y.value;
      });

      console.log("this.cardDataWhereWeAre", this.cardDataWhereWeAre);
      console.log("this.cardDataWantToBe", this.cardDataWantToBe);
      console.log("this.votes", this.cardDataWantToBe);

    },
    reVoting(){
      this.startSegmentVoting();
    },
    async chooseVoting(){
      console.log('Starting voting save with data:', {
        segment: this.selectedSegment.data,
        votes: this.votes,
        selectedVotingValue: this.selectedVotingValue,
        selectedVotingItsOnValue: this.selectedVotingItsOnValue
      });

      try {
        await saveVoting(
          this.customerId, 
          this.workshopId, 
          this.selectedSegment.data.id, 
          this.votes, 
          this.selectedVotingValue.value, 
          this.selectedVotingItsOnValue.value,
          this.departmentId,
          this.projectId
        );
        
        console.log('Voting saved successfully');
        
        this.animateSegment(this.getParentSegmentOfActive().id, this.selectedSegment.data.id);
        
        this.setValue(
          this.getParentSegmentOfActive().id, 
          this.selectedSegment.data.id, 
          this.selectedVotingValue.value, 
          this.selectedVotingItsOnValue.value
        );
        // Allow the segment animation to finish before redrawing from persisted data
        setTimeout(() => {
          this.reloadWorkshopData();
        }, 1200);
        
        this.cancelVoting();
        this.$emit('stopVote');
        this.$emit('initiative-updated');
      } catch (error) {
        console.error('Error saving voting:', error);
      }
    },
    addTime(){
      this.activeVoringEnd = this.activeVoringEnd + 2*60*1000
      setNewVotingEndTime(this.workshopId, this.activeVoringEnd, this.departmentId, this.projectId);
    },
    async endVoting(){
      this.stopVoting();
    },
    cancelVoting(){
      this.votes = [];
      this.votingInProgress = false;
      this.activeVoringStart = undefined;
      this.activeVoringEnd = undefined;
      this.selectedVotingValue = undefined;
      this.selectedVotingItsOnValue = undefined;
      this.votingEnded = false;
      this.detailContentShow = false;
      this.timeString = "";
      this.percentTimeLeft = 100;
      clearInterval(this.timerInterval);
      deleteVoting(this.workshopId, this.departmentId, this.projectId);
    },
    async addTask() {
      if (!this.taskFormValid) return;
      
      const task = {
        id: Date.now().toString(),
        title: this.newTask.title,
        description: this.newTask.description,
        createdAt: new Date().toISOString()
      };
      
      try {
        await this.$workshopFunctions.addTask(
          this.customerId,
          this.workshopId,
          task,
          this.departmentId,
          this.projectId
        );
        
        // Reset form
        this.newTask.title = '';
        this.newTask.description = '';
        
        // Refresh tasks
        await this.loadTasks();
      } catch (error) {
        console.error('Error adding task:', error);
      }
    },
    
    async deleteTask(taskId) {
      try {
        await this.$workshopFunctions.deleteTask(
          this.customerId,
          this.workshopId,
          taskId,
          this.departmentId,
          this.projectId
        );
        
        // Refresh tasks
        await this.loadTasks();
      } catch (error) {
        console.error('Error deleting task:', error);
      }
    },
    
    async loadTasks() {
      try {
        const tasks = await this.$workshopFunctions.loadTasks(
          this.customerId,
          this.workshopId,
          this.departmentId,
          this.projectId
        );
        this.tasks = tasks || [];
      } catch (error) {
        console.error('Error loading tasks:', error);
        this.tasks = [];
      }
    },
    drawSunburst() {
      // Löscht das bestehende SVG, falls vorhanden, um ein neues Diagramm zu zeichnen
      this.$refs.sunburstChart.innerHTML = '';

      const width = 600;
      const radius = width / 2;

      const root = d3.partition()
          .size([2 * Math.PI, radius])(
              d3.hierarchy(this.chartdata)
                  .sum(d => d.sizeValue)
          );

      const arc = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.05)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWantsToBe || 0) * 10 +4)
          .outerRadius(d => d.y1 + (d.data.valueWantsToBe || 0) * 10);
      //.outerRadius(d => d.y1 - 1);


      const arc2 = d3.arc()
          .startAngle(d => d.x0)
          .endAngle(d => d.x1)
          .padAngle(0.05)
          .padRadius(radius / 3)
          .innerRadius(d => d.y0 + (d.data.valueWhereWeAre || 0) * 10 +4)
          .outerRadius(d => d.y1 + (d.data.valueWhereWeAre || 0) * 10);

      const svg = d3.select(this.$refs.sunburstChart).append('svg')
//      const svg = d3.select(this.$refs.sunburstChart.value).append('svg')
          .attr('viewBox', `${-width / 2} ${-width / 2} ${width} ${width}`)
          .style('font', '10px sans-serif');

      const segment = svg.append('g')
          .selectAll('g')
          .data(root.descendants().filter(d => d.depth))
          .join('g');

      segment.append('path')
          .attr('class', 'segmentpart')
          .attr('fill', d => d.data.color)
          .attr('stroke', d => this.lightenDarkenColor(d.data.color, -30))
          .attr('d', arc)
          .attr('id', d => `segment-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`)
          .on('click', d => this.handleSegmentClick(d.currentTarget["__data__"]));


      segment.append('path')
          .attr('class', 'segmentLinePart')
          .attr('fill-opacity', 0)
          .attr('fill', d => d.data.color)
          .attr('stroke', d => d.data.valueWhereWeAre == undefined ? d.data.color : d.data.valueWantsToBe <= d.data.valueWhereWeAre ? 'rgba(0,131,0,0.5)' : 'rgba(173,0,0,0.5)')
          .attr('d', arc2)
          .attr('id', d => `segmentLine-${(d.depth > 1 ? d.parent.data.id + "-" : "") + d.data.id}`)
          .on('click', d => this.handleSegmentClick(d.currentTarget["__data__"]));

      segment.append('text')
          .attr('id', d => `segmentText-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`)
          .attr("transform", d => {
            d.data.d = d;
            const x = arc2.centroid(d)[0];
            const y = arc2.centroid(d)[1];
            const hypotenuse = Math.sqrt(x * x + y * y);
            const xNorm = x / hypotenuse;
            const yNorm = y / hypotenuse;
            const rotation = Math.atan2(yNorm, xNorm) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
            const additionalRotation = rotation < -90 || rotation > 90 ? -180 : 0;
            return `translate(${arc.centroid(d)}) rotate(${rotation + additionalRotation})`;
          })
          .on('click', d => this.handleSegmentClick(d.currentTarget.parentNode["__data__"]))
          .attr("text-anchor", "middle")
          .text(d => d.data.text[this.lang].name)
          .style("fill", "#000")
          .style("font-size", "10px")
          .each(function(d) {
            const bbox = this.getBBox();
            const scale = Math.min(arc.outerRadius()(d) - arc.innerRadius()(d) / bbox.width, arc.outerRadius()(d) - arc.innerRadius()(d) / bbox.height);
            d.scale = scale > 1 ? 1 : scale;
          })
          .attr("class", "segmentpartText wantWeWantToBeText")
          .style("font-size", d => d.scale * 10 + "px")
          .attr("dy", ".35em");
      segment.append('text')
          .attr('id', d => `segmentText2-${(d.depth > 1 ? d.parent.data.id+"-":"")+d.data.id}`)
          .attr("transform", d => {
            d.data.d = d;
            const x = arc2.centroid(d)[0];
            const y = arc2.centroid(d)[1];
            const hypotenuse = Math.sqrt(x * x + y * y);
            const xNorm = x / hypotenuse;
            const yNorm = y / hypotenuse;
            const rotation = Math.atan2(yNorm, xNorm) * (180 / Math.PI); // Umwandlung von Bogenmaß in Grad
            const additionalRotation = rotation < -90 || rotation > 90 ? -180 : 0;
            return `translate(${arc2.centroid(d)}) rotate(${rotation + additionalRotation})`;
          })
          .on('click', d => this.handleSegmentClick(d.currentTarget.parentNode["__data__"]))
          .attr("text-anchor", "middle")
          .text(d => d.data.text[this.lang].name)
          .style("fill", "#000")
          .style("font-size", "10px")
          .each(function(d) {
            const bbox = this.getBBox();
            const scale = Math.min(arc2.outerRadius()(d) - arc2.innerRadius()(d) / bbox.width, arc2.outerRadius()(d) - arc2.innerRadius()(d) / bbox.height);
            d.scale = scale > 1 ? 1 : scale;
          })
          .attr("class", "segmentpartText wantWeAreText")
          .style("font-size", d => d.scale * 10 + "px")
          .attr("dy", ".35em");
    },
    updatePercentTimeLeft() {
      if(this.votingInProgress == true){
        if(this.$refs['divider'] != undefined && this.dividerDivWidth == null){
          this.dividerDivWidth = this.$refs['divider']['offsetWidth'];
          this.buttonWidth = this.$refs['dividerButton']['offsetWidth'];
          this.buttonWidthFrom = this.dividerDivWidth/2-this.buttonWidth/2;
          this.buttonWidthTo = this.dividerDivWidth/2+this.buttonWidth/2;
        }
        const startTime = this.activeVoringStart;
        const endTime = this.activeVoringEnd;

        // eslint-disable-next-line no-unused-vars
        const now = Date.now();
        if (now >= endTime) {
          console.log("now", now)
          console.log("endTime", endTime)
          this.percentTimeLeft = 100;
          this.stopVoting(); // Stoppt den Timer, wenn die Endzeit erreicht ist
        } else {
          const elapsed = now - startTime;
          const total = endTime - startTime;
          const timeLeft = parseInt((endTime - now)/1000);
          let minutes = Math.floor(timeLeft / 60)
          let seconds = timeLeft % 60
          let displayString = `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
          this.timeString = displayString;
          this.percentTimeLeft = 100 - ((elapsed / total) * 100);
          const pixelLeft = this.dividerDivWidth*this.percentTimeLeft/100;

          let buttonPercentTimeLeft = 100;
          if(pixelLeft>this.buttonWidthTo){
            buttonPercentTimeLeft = 100;
          } else if(pixelLeft< this.buttonWidthFrom) {
            buttonPercentTimeLeft = 0;
          } else {
            buttonPercentTimeLeft = 100-((this.buttonWidthTo-pixelLeft)*100/this.buttonWidth);
          }
          // Aktualisiert die CSS-Variable, wenn benötigt
          document.documentElement.style.setProperty('--divider-gradient-percentage', `${this.percentTimeLeft}%`);
          document.documentElement.style.setProperty('--divider-button-gradient-percentage', `${buttonPercentTimeLeft}%`);
          document.documentElement.style.setProperty('--divider-color', this.lightenDarkenColor(this.selectedSegment.data.color, -30));
        }
      }
    },
    // Public method to reload workshop data and redraw the chart
    async reloadWorkshopData() {
      try {
        const res = await loadWorkshop(this.customerId, this.workshopId, this.departmentId, this.projectId);
        if(res == null || res == undefined){
          this.assignProportionalValues(this.chartdata, []);
          this.allVotedAspects = [];
          this.started = false;
        } else {
          this.assignProportionalValues(this.chartdata, res.results);
          this.allVotedAspects = processAllVotedAspects(res.results, segmentRiskData);
          // Keep workshop started based on startDate timestamp
          this.started = !!res.startDate;
        }
        this.drawSunburst();
      } catch (error) {
        console.error('Error reloading workshop data:', error);
      }
    },
    animateSegment(cat, subcat) {
      // Animate the segment by scaling it up and then back to normal
      const segmentId = `segment-${cat}-${subcat}`;
      const segment = document.getElementById(segmentId);
      if (segment) {
        segment.style.transition = 'transform 0.5s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
        segment.style.transform = 'scale(1.2)';
        setTimeout(() => {
          segment.style.transform = 'scale(1)';
        }, 500);
      }
    },
    async fetchSegmentContentLLM(segmentName) {
      const base = import.meta.env.VITE_LLM_BASE || '';
      if (!base) return null; // no remote LLM configured
      const controller = new AbortController();
      const t = setTimeout(() => controller.abort(), 6000);
      try {
        const res = await fetch(`${base}/segment-content`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: segmentName }),
          signal: controller.signal
        });
        clearTimeout(t);
        if (!res.ok) return null;
        return await res.json();
      } catch (e) {
        clearTimeout(t);
        return null;
      }
    },
    async fetchSegmentRecommendationsLLM(segmentName, votingResults, riskScore, riskData) {
      const base = import.meta.env.VITE_LLM_BASE || '';
      if (!base) return null;
      const controller = new AbortController();
      const t = setTimeout(() => controller.abort(), 7000);
      try {
        const res = await fetch(`${base}/segment-recommendations`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: segmentName, votingResults, riskScore, riskData }),
          signal: controller.signal
        });
        clearTimeout(t);
        if (!res.ok) return null;
        return await res.json();
      } catch (e) {
        clearTimeout(t);
        return null;
      }
    },
    onRiskAssessmentToggle() {
      this.$emit('update:riskAssessmentEnabled', this.localRiskAssessmentEnabled);
    },
    onLlmFunctionalityToggle() {
      this.$emit('update:llmFunctionalityEnabled', this.localLlmFunctionalityEnabled);
    },
    async loadProjectDescription() {
      const customerId = this.$store.getters.getCustomerId;
      const descRef = ref(rtdb, `customers/${customerId}/workshop/${this.workshopId}/projectDescription`);
      const snap = await get(descRef);
      if (snap.exists()) {
        this.projectDescription = snap.val();
      } else {
        this.projectDescription = '';
      }
    },
    async saveProjectDescription() {
      const customerId = this.$store.getters.getCustomerId;
      const descRef = ref(rtdb, `customers/${customerId}/workshop/${this.workshopId}/projectDescription`);
      await set(descRef, this.projectDescription);
      this.projectDescriptionDialog = false;
      this.$emit('project-description-updated', this.projectDescription);
    },
  },
  watch: {
    workshopId: {
      immediate: true,
      handler() {
        this.reloadWorkshopData();
      }
    },
    customerId() {
      this.reloadWorkshopData();
    },
    departmentId() {
      this.reloadWorkshopData();
    },
    projectId() {
      this.reloadWorkshopData();
    },
    riskAssessmentEnabled(newVal) {
      this.localRiskAssessmentEnabled = newVal;
    },
    llmFunctionalityEnabled(newVal) {
      this.localLlmFunctionalityEnabled = newVal;
    }
  },
  props: {
    riskAssessmentEnabled: {
      type: Boolean,
      required: true
    },
    updateRiskAssessment: {
      type: Function,
      required: true
    },
    llmFunctionalityEnabled: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style>
.detailCard {
  max-height: 90vh;
  overflow-y: auto;
}

.detailCardContainer {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.description-section {
  background: rgba(0, 0, 0, 0.03);
  padding: 16px;
  border-radius: 8px;
}

.voting-section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cards-row {
  display: flex;
  overflow-x: auto;
  padding: 8px 0;
  min-width: 0;
  margin: 0 -8px;
}

/* Responsive layout for results (no horizontal scroll) */
.results-grid {
  display: grid !important;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  padding: 8px 0;
  margin: 0;
  overflow: visible;
}
.results-grid .voting-card {
  flex: initial;
  min-width: 0;
  max-width: none;
  width: 100%;
}

.voting-card {
  flex: 0 0 calc(100% / 7 - 8px);
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  min-width: 140px;
  max-width: 200px;
  background: #fff;
  margin: 0 4px;
}

.voting-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.voting-card.selected-card {
  border: 2px solid #1976d2 !important;
  background-color: #e3f0fb !important;
  box-shadow: 0 0 8px #1976d233;
}

.voting-card-headline {
  font-size: 24px !important;
  text-align: center;
  padding: 8px !important;
  font-weight: 500;
  color: var(--v-primary-base);
}

.voting-card-text {
  flex-grow: 1;
  padding: 8px !important;
  text-align: center;
  font-size: 14px;
  color: rgba(0,0,0,0.87);
  line-height: 1.4;
}

.voting-card-divider {
  height: 1px;
  background-color: rgba(0,0,0,0.12);
}

.voting-card-vote {
  padding: 0.5rem;
  text-align: center;
  background: rgba(0,0,0,0.03);
}

.titleCardContainer {
  padding: 16px 16px 0 16px;
  font-size: 1.25rem;
  font-weight: 500;
  color: rgba(0,0,0,0.87);
}

/* Scrollbar styling */
.cards-row::-webkit-scrollbar {
  height: 8px;
}

.cards-row::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.cards-row::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
  border: 2px solid #f1f1f1;
}

.cards-row::-webkit-scrollbar-thumb:hover {
  background: #666;
}

/* Add background to prevent seeing through */
.detailCardContainer {
  background: white;
  position: relative;
  z-index: 1;
  padding-bottom: 80px; 
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* Card container styles */
.cards-row {
  display: flex;
  overflow-x: auto;
  padding: 20px 20px 20px 80px; 
  margin: 0;
  background: white;
  position: relative;
  z-index: 2;
  gap: 20px; 
}

/* Wheel container styles */
.svgContainer {
  position: relative;
  width: 100%;
  height: calc(100vh - 180px); /* header + tabs padding */
  display: flex;
  align-items: center;
  justify-content: center;
  /* Add a little breathing room below the tabs to avoid overlap */
  margin-top: 64px;
  overflow: visible;
  padding: 0;
}

.chart {
  width: min(90vw, 600px);
  height: min(calc(100vh - 220px), 600px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: visible;
  padding: 0;
  margin: 0 auto;
  position: relative;
  transform-origin: center;
}

.svgContainer svg {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  overflow: visible !important;
  transform: none;
  transform-origin: center;
  margin: 0;
}

/* SVG element styles */
.segmentpart {
  stroke: none;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.segmentpartText {
  cursor: pointer;
  pointer-events: none;
  font-size: 11px;
  font-weight: 500;
  dominant-baseline: middle;
  text-anchor: middle;
  fill: rgba(0, 0, 0, 0.87); 
}

/* Ensure expanded segments have enough space */
.segmentpart.expanded {
  transform-origin: center;
  transform-box: fill-box;
}

/* Remove any clipping masks */
.chart > svg > g {
  overflow: visible !important;
}

/* Card styles */
.card {
  min-width: 180px;
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  height: 200px;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.card-headline {
  font-size: 2rem !important;
  text-align: center !important;
  width: 100% !important;
  padding: 1rem !important;
  min-height: 60px;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.card-text {
  flex-grow: 1;
  padding: 0.75rem;
  font-size: 0.875rem;
  line-height: 1.4;
  overflow-y: auto;
  word-wrap: break-word;
}

.card-vote {
  padding: 0.5rem;
  text-align: center;
  background: rgba(0,0,0,0.03);
}

.card-divider {
  height: 1px;
  background-color: rgba(0,0,0,0.12);
}

.detailButtons {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background: white;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  border-top: 1px solid rgba(0,0,0,0.12);
  z-index: 3;
}

/* Dialog styles */
.app-dialog {
  background: transparent !important;
}

.dialog-card {
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1976D2 !important;
  color: white !important;
  padding: 16px !important;
}

.close-btn {
  color: white !important;
}

/* Make dialog background transparent */
:deep(.v-overlay__content) {
  background: transparent !important;
  box-shadow: none !important;
}

:deep(.v-overlay__scrim) {
  opacity: 0 !important;
}

/* Radio button styling */
:deep(.v-radio-group) {
  gap: 8px;
}

:deep(.v-radio) {
  margin: 0;
}

/* List styling */
:deep(.v-list) {
  padding: 0;
  background: transparent;
}

:deep(.v-list-item) {
  min-height: 48px;
  padding: 0 16px;
}

/* Filter visibility styles */
.showAll .wantWeAreText {
  opacity: 0;
}

.showWhereWeAre .segmentpart {
  display: none;
}

.showWhereWeAre .segmentLinePart {
  fill-opacity: 1;
  stroke-opacity: 0;
}

.showWhereWeAre .wantWeWantToBeText {
  opacity: 0;
}

.showWhereWeAre .wantWeAreText {
  opacity: 1;
}

.showWhereWeWantToBe .segmentLinePart {
  display: none;
}

.showWhereWeWantToBe .wantWeAreText {
  opacity: 0;
}

/* Animation styles */
@keyframes pulse {
  0% {
    stroke-width: 0;
    stroke-opacity: 1;
  }
  50% {
    stroke-width: 2px;
    stroke-opacity: 0.5;
  }
  100% {
    stroke-width: 0;
    stroke-opacity: 1;
  }
}

.selected {
  animation: pulse 1.5s infinite;
}

/* Top-right button styles */
.top-actions {
  position: fixed !important;
  /* place actions into the header area, leaving room for Exit icon on far right */
  top: 16px !important;
  right: 64px !important;
  z-index: 1500 !important;
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-btn {
  margin: 0 !important;
}

/* QR code dialog styles */
.qr-dialog {
  background: transparent !important;
}

.qr-card {
  background: white;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #1976D2 !important;
  color: white !important;
  padding: 16px !important;
}

.close-btn {
  color: white !important;
}

/* Make dialog background transparent */
:deep(.v-overlay__content) {
  background: transparent !important;
  box-shadow: none !important;
}

:deep(.v-overlay__scrim) {
  opacity: 0 !important;
}

/* QR code specific styles */
.qr-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px !important;
}

.qr-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin: 0 auto;
}

/* Task dialog styles */
.task-dialog {
  border-radius: 8px;
  overflow: hidden;
}

.task-dialog-content {
  max-height: 80vh;
  overflow-y: auto;
}

.task-dialog .v-table {
  background: transparent;
  border-radius: 8px;
}

.task-dialog .v-table th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  background: var(--v-grey-lighten-4);
}

.task-dialog .v-table td {
  height: 48px;
  color: rgba(0, 0, 0, 0.87);
}

.task-dialog .v-table tr:hover td {
  background: var(--v-grey-lighten-5);
}

.task-dialog .v-card-text {
  padding: 24px;
}

/* Voting cards styles */
.cards-row {
  display: flex;
  gap: 8px;
  padding: 8px 0;
  overflow-x: auto;
  min-width: 0;
  margin: 0 -8px;
}

.voting-card {
  flex: 0 0 calc(100% / 7 - 8px);
  display: flex;
  flex-direction: column;
  padding: 16px;
  border-radius: 8px;
  transition: all 0.2s ease;
  cursor: pointer;
  min-width: 140px;
  max-width: 200px;
  background: #fff;
  margin: 0 4px;
}

.voting-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1) !important;
}

.voting-card.selected-card {
  border: 2px solid var(--v-primary-base);
  background-color: var(--v-primary-lighten-5);
}

.voting-card-headline {
  font-size: 24px !important;
  text-align: center;
  padding: 8px !important;
  font-weight: 500;
  color: var(--v-primary-base);
}

.voting-card-text {
  flex-grow: 1;
  padding: 8px !important;
  text-align: center;
  font-size: 14px;
  color: rgba(0,0,0,0.87);
  line-height: 1.4;
}

.voting-card-divider {
  height: 1px;
  background-color: rgba(0,0,0,0.12);
}

.voting-card-vote {
  padding: 0.5rem;
  text-align: center;
  background: rgba(0,0,0,0.03);
}

@media (max-width: 600px) {
  .cards-row {
    flex-wrap: wrap;
    justify-content: center;
  }

  .voting-card {
    flex: 0 0 calc(50% - 16px);
    min-width: 120px;
  }

  .voting-card-headline {
    font-size: 20px !important;
  }

  .voting-card-text {
    font-size: 13px;
  }
}

.global-risk-score-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.5rem;
  font-weight: 700;
  color: #222;
  background: rgba(255,255,255,0.85);
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  pointer-events: none;
}

.iso-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  font-size: 1.4rem;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.05em;
}

.votes-count-chip {
  position: absolute;
  right: 16px;
  top: 16px;
  z-index: 2;
  font-size: 1rem;
  background: #e3f2fd;
  color: #1976d2;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(25, 118, 210, 0.08);
}

.edit-description-btn {
  /* Ensures same size, margin, and alignment as other icons */
  margin: 0 !important;
}

.v-input--switch .v-input__track {
  background-color: #bdbdbd !important;
}
.v-input--switch .v-input__track--active {
  background-color: #1976d2 !important;
}
</style>
